module.exports = require("tree-kill");